import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Grid, Tooltip, Typography, useTheme } from '@mui/material';
import { VisitorGroup } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { getAmountOfKeySharingManagers, getKeySharingInvitedMembers } from 'utils/VisitorGroup/VisitorGroup';
import useDrawerContext from 'v2/components/Drawer/useDrawerContext';
import EditableCard from 'v2/components/EditableCard/EditableCard';
import EditKeySharingDrawer from '../drawers/EditKeySharingDrawer/EditKeySharingDrawer';

interface Props {
  visitorGroup: VisitorGroup;
}

const KeySharing: React.FC<Props> = ({ visitorGroup }) => {
  const { translation } = useTranslation();
  const theme = useTheme();
  const { openDrawer } = useDrawerContext();

  const handleEditKeySharingGroup = () => {
    openDrawer(<EditKeySharingDrawer visitorGroupId={visitorGroup.id} />);
  };

  const amountOfKeySharingManagers = getAmountOfKeySharingManagers(visitorGroup);
  const amountOfInvitedUsers = getKeySharingInvitedMembers(visitorGroup).length;

  return (
    <EditableCard
      title={translation.key_sharing}
      titleAdornment={
        <Tooltip title={translation.key_sharing_tooltip} placement="top">
          <InfoOutlined color="action" sx={{ width: '20px', height: '20px' }} />
        </Tooltip>
      }
      editButtonId="editKeySharingVisitorGroup"
      onEditClick={() => handleEditKeySharingGroup()}
      spacing={2}
    >
      <Grid container direction="row" size={12} wrap="nowrap" spacing={1}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          size={6}
          sx={{ backgroundColor: theme.custom.background.level2, padding: '10px 16px', width: '100%' }}
        >
          <Typography>{translation.key_managers}</Typography>
          <Typography>{amountOfKeySharingManagers}</Typography>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          size={6}
          sx={{ backgroundColor: theme.custom.background.level2, padding: '10px 16px', width: '100%' }}
        >
          <Typography>{translation.invited_users}</Typography>
          <Typography>{amountOfInvitedUsers}</Typography>
        </Grid>
      </Grid>
    </EditableCard>
  );
};

export default KeySharing;
